<template>
  <div class="live-video">
    <main class="main-content">
      <b-container fluid="xl" class="section-1">
        <h2 class="live-video-section-title">{{$t('live-video-section-title-1')}}</h2>
        <b-row class="mt-1">
          <b-col v-for="(video, index) in videos" :key=index class="p-4" cols="12" xl="6" md="6" sm="12">
            <b-embed
              type="video"
              preload="metadata"
              controls
              aspect="16by9"
              allowfullscreen
            >
              <source :src="video.src" type="video/mp4">
            </b-embed>
            <span class="video-title">{{video.title}}</span>
          </b-col>
        </b-row>
      </b-container>
    </main>
  </div>
</template>

<script>
import runtime from '../utils/runtime'

const videoFiles = require.context('../assets/videos', false, /\.(mp4)$/)

const videos = videoFiles.keys().reduce((videos, videoKey) => {
  const videoName = videoKey.replace(/^\.\/(.*)\.\w+$/, '$1')
  videos.push({
    title: videoName,
    src: videoFiles(videoKey)
  })
  return videos
}, [])

export default {
  name: 'LiveVideo',
  data () {
    return {
      isMobile: runtime.isMobile(),
      videos: videos
    }
  },
  mounted () {
    document.title = 'Video Analytics'
  }
}
</script>
<style lang="scss" scoped>
  .live-video {
    .main-content {
      margin-top: 80px;
      padding-bottom: 100px;

      .live-video-section-title {
        font-size: 34px;
        font-weight: 700;
        color: #000000;
      }

      .live-video-section-sub-title {
        font-size: 24px;
        font-weight: 400;
        color: #000000;
        line-height: 1.4;
        margin-top: 16px;
      }

      .video-title {
        display: block;
        font-size: 1.2rem;
        font-weight: 700;
        text-align: left;
        color: #000000;
        margin-top: 0.5rem;
      }
      .section-1{

      }
    }

  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .row-title {
      font-size: 20px !important;
    }
    .row-detail {
      font-size: 16px !important;
      margin-top: 10px !important;
    }
    .main-content {
      margin-top: 33px !important;
    }
    .live-video-section-title {
      font-size: 20px !important;
      text-align: left;
    }
    .live-video-section-sub-title {
      font-size: 12px !important;
      text-align: left;
    }
    .video-title {
      font-size: 14px !important;
      margin-top: 24px;
    }
  }
</style>
